import React from 'react';
import './masters.css';
import { useDispatch, useSelector } from "react-redux";
import MasterForm from "../MasterForm/MasterForm";
import MasterScheduleForm from "../MasterScheduleForm/MasterScheduleForm";
import MasterScheduleTimesForm from "../MasterScheduleTimesForm/MasterScheduleTimesForm";
import { setMasterFormAction } from "../../redux/rootReducer";
import { MASTER_FORM_INITIAL } from "../../redux/initialStateConstant";
import { GetMasterByIdThunk } from "../../redux/thunks/GetMasterByIdThunk";
import { RemoveMasterThunk } from "../../redux/thunks/RemoveMasterThunk";
import { GetScheduleThunk } from "../../redux/thunks/GetScheduleThunk";

const Masters = () => {
    const dispatch = useDispatch();
    const services_settings = useSelector(state => state.services_settings);
    const master_form = useSelector(state => state.master_form);
    const master_schedule_form = useSelector(state => state.master_schedule_form);
    const master_schedule_times_form = useSelector(state => state.master_schedule_times_form);

    return (
        <>
            { master_form.open && <MasterForm/> }
            { master_schedule_form.open && <MasterScheduleForm/> }
            { master_schedule_times_form.open && <MasterScheduleTimesForm/> }
            <div className="services_settings services_settings--masters">
                <div className="services_settings__header services_settings__header--masters">
                    <div className="services_settings__add button button--blue"
                        onClick={ () => {
                            dispatch(setMasterFormAction({
                                ...MASTER_FORM_INITIAL,
                                open: true
                            }));
                        } }
                    >Добавить мастера</div>
                </div>
                {
                    services_settings.masters.length > 0
                        ?
                        <div className="table">
                            <div className="table__row table__row--header table__row--masters">
                                <div className="table__cell">№</div>
                                <div className="table__cell">Имя</div>
                                <div className="table__cell">Специализация</div>
                                <div className="table__cell"/>
                                <div className="table__cell"/>
                                <div className="table__cell"/>
                            </div>
                            {
                                services_settings.masters.map((elem, index) => {
                                    return (
                                        <div className="table__row table__row--masters" key={ elem.id }>
                                            <div className="table__cell">{ index + 1}</div>
                                            <div className="table__cell">{ elem.name }</div>
                                            <div className="table__cell">{ elem.specialization }</div>
                                            <div className="table__cell table__cell--hover"
                                                onClick={ () => {
                                                    dispatch(GetScheduleThunk({
                                                        master_id: elem.id
                                                    }));
                                                } }
                                            >Расписание</div>
                                            <div className="table__cell table__cell--no-overflow">
                                                <div className="control control--edit"
                                                    onClick={ () => {
                                                        dispatch(GetMasterByIdThunk({
                                                            master_id: elem.id
                                                        }));
                                                    } }
                                                />
                                            </div>
                                            <div className="table__cell table__cell--no-overflow">
                                                <div className="control control--remove"
                                                    onClick={ () => {
                                                        if (!window.confirm('Вы действительно хотите удалить мастера?')) return;

                                                        dispatch(RemoveMasterThunk({
                                                            master_id: elem.id
                                                        }));
                                                    } }
                                                />
                                            </div>
                                        </div>
                                    );
                                })
                            }
                        </div>
                        :
                        <div className="empty__list">Нет сохранённых мастеров</div>
                }
            </div>
        </>
    );
};

export default Masters;